import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { UrlService } from '@core/services/url/url.service';
import { HttpClient } from '@angular/common/http';

import * as fromOrganizationActions from '../../store/state/settings/organization/organization.actions';
import * as fromOrganizationState from '../../store/state/settings/organization/organization.state';

@Injectable({
    providedIn: 'root'
})
export class SettingsOrganizationService {
    constructor(private store: Store, private urlSrv: UrlService, private http: HttpClient) {}

    /**
     * Dispatches the updateOrganization action to update the organization name.
     *
     * @param {string} name - The new name of the organization.
     */
    public updateOrganization(name: string) {
        this.store.dispatch(fromOrganizationActions.updateOrganization({ name }));
    }

    /**
     * Dispatches the uploadLogo action to upload a new organization logo.
     *
     * @param {string} fileId - The ID of the file to upload.
     * @param {object} options - Additional options for the upload.
     */
    public uploadLogo(fileId: string, options: object) {
        this.store.dispatch(fromOrganizationActions.uploadLogo({ fileId, options }));
    }

    /**
     * Dispatches the deleteLogo action to delete the current organization logo.
     */
    public deleteLogo() {
        this.store.dispatch(fromOrganizationActions.deleteLogo());
    }

    /**
     * Selects the update status as an observable stream.
     *
     * @returns {Observable<number>} - An observable emitting the update status.
     */
    public selectUpdateStatus = (): Observable<number> => this.store.select(fromOrganizationState.selectUpdateStatus);

    /**
     * Selects the upload status as an observable stream.
     *
     * @returns {Observable<number>} - An observable emitting the upload status.
     */
    public selectUploadStatus = () : Observable<number> => this.store.select(fromOrganizationState.selectUploadStatus);

    /**
     * Selects the delete status as an observable stream.
     *
     * @returns {Observable<number>} - An observable emitting the delete status.
     */
    public selectDeleteStatus = (): Observable<number> => this.store.select(fromOrganizationState.selectDeleteStatus);

    /**
     * Selects the error state for organization actions as an observable stream.
     *
     * @returns {Observable<HttpErrorResponse>} - An observable emitting any error that occurred during organization actions.
     */
    public selectErrorActions = (): Observable<HttpErrorResponse> => this.store.select(fromOrganizationState.selectErrorActions);

    
    /**
     * Dispatches the clean action failiures on organization logo errors.
     */
    public clearActionFailures() {
        this.store.dispatch(fromOrganizationActions.clearLogoFailures());
    }
}
